import React from 'react';

const FormInputLabel = (props) => {
  const {
    question,
    uniqueFormString,
    isFieldsetLabel
  } = props;

  if (isFieldsetLabel) {
    return (
      <span className="form-input-label">
        <span className="form-input-label-text">
          {question.label}
        </span>
        {question.isRequired ||
          <span className="form-input-optional-text">(optional)</span>
        }
      </span>
    );
  }

  return (
    <label htmlFor={`${question.name}-${uniqueFormString}`} className="form-input-label">
      <span className="form-input-label-text">
        {question.label}
      </span>
      {question.isRequired ||
        <span className="form-input-optional-text">(optional)</span>
      }
    </label>
  );
};

export default FormInputLabel;